import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  CircularProgress,
} from "@material-ui/core";
import * as api from "../forecastApi";

export default function CMOSelect({ value, onChange }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    setLoading(true);
    api
      .fetchCMOMembers(ctrl.signal)
      .then((res) => {
        if (res && res.status) {
          setOptions(res.CMOMembersWithId || res.data || []);
        }
      })
      .catch(() => { })
      .finally(() => setLoading(false));
    return () => ctrl.abort();
  }, []);

  const handleChange = (e) => {
    const id = e.target.value;
    const opt = options.find((o) => o.organization_id === id);
    onChange(id, opt ? opt.organization_name : "");
  };

  return (
    <FormControl fullWidth>
      <InputLabel shrink>
        Select CMO <span style={{ color: "red" }}>*</span>
      </InputLabel>
      <Select value={value || ""} onChange={handleChange} disabled={loading} displayEmpty>
        <MenuItem value="" disabled>
          {loading ? <CircularProgress size={16} /> : "Select CMO"}
        </MenuItem>
        {options.map((o) => (
          <MenuItem key={o.organization_id} value={o.organization_id}>
            {o.organization_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
